import React, { Component } from "react";

import { filterSecondaryCarrierOptions } from "@/features/insurance/helpers/filter-secondary-options";
import ImageFullPreview from "@/components/Common/ImageFullPreview";
import { patientRequests } from "@/api/(requests)/patient";
import {
  PRI_INSURANCE_SCHEMA,
  SEC_INSURANCE_SCHEMA,
} from "@/containers/Dashboard/Patient/schema/PatientProfileInfoSchema";
import { trackPolicyAcknowledgement } from "@/utils/acknowledgementUtils";

import InsuranceInfo from "./InsuranceInfo";
import { PRI, SEC } from "./Profile";

class PatientProfileInsuranceInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      acknowledgements: {},
      carrierOptions: [],
      contentType: null,
      stateOptions: [],
    };
  }

  componentDidMount() {
    // TODO: Consider migrating to useInsuranceList hook when refactoring to functional component
    // See MemberProfileMedical.js for reference implementation
    patientRequests
      .fetch_insurance_list({ context: { showLoader: false } })
      .then((response) => {
        const carrierOptions = response.carriers.map((carrier) => {
          return { label: carrier, value: carrier };
        });

        const stateOptions = response.state.map((state) => {
          return { label: state, value: state };
        });

        // modify original schema with received options list defined and set them in state
        PRI_INSURANCE_SCHEMA.forEach((el) => this.setInsOptions(el, carrierOptions, stateOptions));
        SEC_INSURANCE_SCHEMA.forEach((el) => this.setInsOptions(el, carrierOptions, stateOptions));

        this.setState({
          carrierOptions,
          pri_insurance_schema: PRI_INSURANCE_SCHEMA,
          sec_insurance_schema: SEC_INSURANCE_SCHEMA,
          stateOptions,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setInsOptions = (el, carrierOptions, stateOptions) => {
    if (el.elementConfig && el.elementConfig.label === "Carrier") {
      el.elementConfig.options = carrierOptions;
    } else if (el.elementConfig && el.elementConfig.label === "State") {
      el.elementConfig.options = stateOptions;
    }
  };

  submitInsHandler = (formData, action) => {
    const data = {
      ...this.props.data,
      ...formData,
    };

    data.acknowledgements = {
      ...data.acknowledgements,
      ...this.state.acknowledgements,
    };
    this.props.submit(data, action, this.props.type);
  };

  renderImgFullPreview = (url, contentType) => {
    this.setState({
      contentType: contentType,
      insFullPreviewUrl: url,
    });
  };

  closeFullPreview = () => {
    this.setState({
      insFullPreviewUrl: null,
    });
  };

  addAcknowledgement = (policyName, acknowledgement) => {
    const { data } = this.props;

    if (data.acknowledgements && !data.acknowledgements[policyName]) {
      const acknowledgements = {
        ...this.state.acknowledgements,
        [policyName]: acknowledgement,
      };

      this.setState({ acknowledgements });
      trackPolicyAcknowledgement(policyName);
    }
  };

  render() {
    let bContentType, bUrl, fContentType, fUrl, ins;

    // Filter out excluded carriers for secondary insurance only
    const carrierOptions =
      this.props.type === SEC
        ? filterSecondaryCarrierOptions(this.state.carrierOptions)
        : this.state.carrierOptions;

    if (PRI === this.props.type) {
      fUrl = this.props.insuranceImageUrls.pfUrl;
      fContentType = this.props.insuranceImageTypes.pfType;
      bContentType = this.props.insuranceImageTypes.pbType;
      bUrl = this.props.insuranceImageUrls.pbUrl;
      ins = this.props.data.primary_insurance;
    } else {
      fUrl = this.props.insuranceImageUrls.sfUrl;
      fContentType = this.props.insuranceImageTypes.sfType;
      bContentType = this.props.insuranceImageTypes.sbType;
      bUrl = this.props.insuranceImageUrls.sbUrl;
      ins = this.props.data.secondary_insurance;
    }

    return (
      <>
        {this.state.insFullPreviewUrl && (
          <ImageFullPreview
            close={this.closeFullPreview}
            contentType={this.state.contentType}
            url={this.state.insFullPreviewUrl}
          />
        )}

        <InsuranceInfo
          {...this.props}
          addAcknowledgement={this.addAcknowledgement}
          carrierOptions={carrierOptions}
          completedTitle={this.props.completedTitle}
          edit={this.props.edit}
          editTitle={this.props.editTitle}
          emptyDetails={this.props.emptyDetails}
          emptyTitle={this.props.emptyTitle}
          insurance={ins}
          insuranceImageStatuses={this.props.insuranceImageStatuses}
          insuranceImageUrls={this.props.insuranceImageUrls}
          isEditing={this.props.edit}
          onAddButtonClick={this.props.onEdit}
          onBackImageClick={() => this.renderImgFullPreview(bUrl, bContentType)}
          onCancelButtonClick={this.props.onEdit}
          onEdit={this.props.onEdit}
          onEditButtonClick={this.props.onEdit}
          onFrontImageClick={() => {
            this.renderImgFullPreview(fUrl, fContentType);
          }}
          stateOptions={this.state.stateOptions}
          submit={this.submitInsHandler}
          type={this.props.type}
        />
      </>
    );
  }
}
export default PatientProfileInsuranceInfo;
